import { WidgetTitle } from "./widget-title";
import { WidgetWrapper } from "./widget-wrapper";

const Widget = {};
Widget.Wrapper = WidgetWrapper;
Widget.Title = WidgetTitle;

export { Widget };
